import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <h2 className="section-title">O nás</h2>
        
        <div className="about-card">
          <div className="about-image">
            <img src="/fotky/medailonek2.jpg" alt="Tomáš Jelínek" />
          </div>
          <div className="about-text">
            <div className="about-header">
              <h3>Tomáš Jelínek</h3>
            </div>
            <div className="about-details">
              <p>Majitel obchodu</p>
              <p>Mistr ČR ve speed trialu</p>
              <p>Vlastní cykloobchod od roku 2005</p>
              <p>Zkušenosti v oboru více než 20 let</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

